 
export class MultipleChoiceSvarSave {
        public id: string;
        public konkurrenceId: string;
        public delopgaveId: string;
        public holdId: string;
        public multipleChoiceSvarmulighedId: string;
        public multipleChoiceSpoergsmaalId: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/MultipleChoiceSvarSave.ts